// Constantes del módulo Pre-Visit Planning (Módulo D — BillingV2).

// ---------------------------------------------------------------------------
// Acceso al módulo
// ---------------------------------------------------------------------------
//
// Lo decide SOLO la matriz RBAC: `previsit_planning` (25) del catálogo,
// mapeado en app/AccessDenied/roleRoutePermissions.js. Para dar acceso a
// alguien, concederle el módulo en Administration -> Access Control.
//
// 2026-08-31: se eliminaron de acá PREVISIT_ALLOWED_EMPLOYEE_IDS y
// canUserAccessPrevisit, junto con el guard que los aplicaba. Eran del piloto,
// de cuando el módulo no estaba en el catálogo, y al registrarse quedaron como
// un segundo gate invisible: conceder el módulo no alcanzaba y el usuario caía
// en /AccessDenied sin explicación. Lo mismo se retiró de CDCI, Patient
// Geography y Clinical Notes Transcriptor, que compartían esta misma lista.
//
// ⚠️ DEUDA: `REACT_APP_PREVISIT_EMPLOYEES` sigue definida en .env,
// .env.production y .env.example pero YA NO LA LEE NADIE. Conviene borrar esas
// tres líneas: agregar un id ahí no da acceso a ningún módulo, y creer que sí
// es exactamente la confusión que este cambio elimina.
//
// Lo que queda abajo (hasPrevisitRoleAccess) NO es acceso: es alcance de datos
// —qué citas ve cada uno una vez adentro— junto con common/providerAccess.js.

/**
 * Roles con acceso pleno al módulo (ven la jornada completa, sin restricción
 * por provider). Se resuelven por roleKey/roleName del backend — nunca por ID
 * numérico, que puede cambiar entre entornos.
 *
 * Hoy: "Clinical Access" (TAB_ROLE 21 en prod, solo como referencia).
 */
const PREVISIT_FULL_ACCESS_ROLE_KEYS = new Set(["clinical_access"]);
const PREVISIT_FULL_ACCESS_ROLE_NAMES = new Set(["clinical access"]);

/**
 * ¿El rol activo del usuario tiene acceso pleno al módulo?
 *
 * @param {Object|null|undefined} user - user de AuthContext (usa activeRole)
 * @returns {boolean}
 */
export const hasPrevisitRoleAccess = (user) => {
  const key = user?.activeRole?.key;
  if (key && PREVISIT_FULL_ACCESS_ROLE_KEYS.has(String(key).toLowerCase())) return true;
  const name = user?.activeRole?.name;
  return Boolean(name && PREVISIT_FULL_ACCESS_ROLE_NAMES.has(String(name).toLowerCase()));
};

/** Estados del prep packet por cita. */
export const PREP_STATUS = {
  PENDING: "pending",
  READY: "ready",
  REVIEWED: "reviewed",
};

/** Mapa estado → tono semántico + label (siempre texto + color, nunca solo color). */
export const PREP_STATUS_META = {
  [PREP_STATUS.PENDING]: { tone: "warn", label: "Prep pending" },
  [PREP_STATUS.READY]: { tone: "info", label: "Prep ready" },
  [PREP_STATUS.REVIEWED]: { tone: "ok", label: "Reviewed by staff" },
};

/** Claves del selector de fecha del shell. */
export const DATE_KEYS = {
  TODAY: "today",
  TOMORROW: "tomorrow",
};

export const DATE_OPTIONS = [
  { value: DATE_KEYS.TODAY, label: "Today" },
  { value: DATE_KEYS.TOMORROW, label: "Tomorrow" },
];

/** Prioridad de care gap → tono. */
export const GAP_PRIORITY_TONE = {
  high: "crit",
  medium: "warn",
  low: "muted",
};
